<template>
  <div class="bill-footer-container">
    <div class="btn-container">
      <rich-button @click="handleBack">
        {{ $t('FoodC_subscription_uipE_quiy') }}
      </rich-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BillFooter',
  methods: {
    handleBack() {
      this.SodaBridge('closePage')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mixin.scss';

.bill-footer-container {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 8;
  width: 750px;
  background: #fff;
  padding: 16px 24px 45px 24px;
  box-sizing: border-box;
  // box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.04);
  // border-radius: 40px 40px 0 0;
  .rich-btn {
    @include globalBigBtn();
  }
}
</style>
